import Prism from 'prismjs';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

const CodeInline = ({ code, language }) => {
  const codeRef = useRef();
  useEffect(() => {
    if (codeRef && codeRef.current) {
      Prism.highlightElement(codeRef.current);
    }
  }, [codeRef]);

  return (
    <code className={`language-${language}`} ref={codeRef}>
      {code.trim()}
    </code>
  );
};

CodeInline.defaultProps = {
  language: 'js',
};

// language types: if more are added, you must also adjust the babel config
// https://prismjs.com/#supported-languages
CodeInline.propTypes = {
  code: PropTypes.string.isRequired,
  language: PropTypes.oneOf(['bash', 'css', 'html', 'js']),
};

export default CodeInline;
